import { Col } from 'reactstrap';
import styled from 'styled-components';
import { parseProp, parseTheme } from 'mol-ui';

export const Data = styled.dd`
    ${ parseTheme('color', 'textColor') };
    display: inline-block;
    font-size: 13px;
    ${ parseProp('fontWeight', 'font-weight') };
    margin: 0;
    margin-left: 5px;
    word-break: break-all;
`;

export const Item = styled.div`
    display: flex;
    margin: 0px 10px 10px 10px;
    margin-left: 0;
`;

export const StyledCol = styled(Col)`
    padding: 0px;
`;

export const Title = styled.dt`
    ${ parseTheme('color', 'textColor') }
    display: inline-block;
    font-size: 13px;
    font-weight: normal;
    margin: 0;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
